import React, { useEffect, useState } from "react";
import axiosClient from "../../../../config/axios.js";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";

function TypeServices() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");

  const deleteTypeService = (id) => {
    Swal.fire({
      title: "¿Está seguro que desea borrar el Tipo de Servicio seleccionado?",
      text: "Una vez eliminado, no podrá recuperarlo.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosClient.delete(`/typeServices/${id}`).then(() => {
          fetchData();
          Swal.fire(
            "Eliminado",
            "El Tipo de Servicio ha sido eliminado.",
            "success"
          );
        });
      }
    });
  };

  const fetchData = async (
    currentPage = 1,
    search = "",
    sortField,
    sortDirection
  ) => {
    try {
      const response = await axiosClient.get(`/typeServices/datatable`, {
        params: {
          start: (currentPage - 1) * rowsPerPage,
          length: rowsPerPage,
          search: search,
          sort: sortField,
          dir: sortDirection,
        },
      });
      //console.log(response.data);
      
      setData(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setLoading(true);
    fetchData(currentPage, searchValue, sortField, sortDirection);
  }, [currentPage, rowsPerPage, sortField, sortDirection]);

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true, sortField: "id" },
    {
      name: "Tipo de Servicio",
      selector: (row) => row.type_service_name,
      sortable: true,
      sortField: "type_service_name",
    },
    {
      name: "Clave de producto",
      selector: (row) => row.id_productKey,
      sortable: true,
      sortField: "id_productKey",
    },
    {
      name: "Clave de unidad",
      selector: (row) => row.id_unitKey,
      sortable: true,
      sortField: "id_unitKey",
    },
    {
      name: "Editar",
      button: true,
      cell: (row) => (
        <Link to={`/catalogs/type-services/edit/${row.id}`}>
          <i className="fa fa-pencil" />
        </Link>
      ),
    },
    {
      name: "Eliminar",
      button: true,
      cell: (row) => (
        <a href="#" onClick={() => deleteTypeService(row.id)}>
          <i className="fa fa-trash" />
        </a>
      ),
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
        backgroundColor: "#EEEEEE",
        border: "none",
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: false,
    selectAllRowsItemText: "Todos",
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      setLoading(true);
      setCurrentPage(1);
      fetchData(1, searchValue, sortField, sortDirection);
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">Configuración</li>
            <li className="breadcrumb-item active">Tipos de Servicio</li>
          </ol>
          <h1 className="page-header mb-0">Tipos de Servicio</h1>
        </div>
        <div className="ms-auto">
          <Link
            to={"/catalogs/type-services/newTypeService"}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>{" "}
            Nuevo Tipo de Servicio
          </Link>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Listado de Tipos de Servicio</PanelHeader>
            <PanelBody>
              <DataTable
                className="table"
                columns={columns}
                data={data.data}
                progressPending={loading}
                sortServer
                pagination
                paginationServer
                paginationPerPage={rowsPerPage}
                paginationTotalRows={data.recordsTotal}
                paginationDefaultPage={currentPage}
                subHeader
                customStyles={customStyles}
                pointerOnHover
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent="Sin información por mostrar"
                progressComponent={
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Cargando...</span>
                  </Spinner>
                }
                subHeaderComponent={
                  <div className="row">
                    <div className="col-sm-12 col-md-12">
                      <div className="input-group mb-3">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Buscar..."
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          onKeyPress={handleKeyPress}
                        />
                        <div
                          className="input-group-text btn btn-info"
                          onClick={() => {
                            setLoading(true);
                            setCurrentPage(1);
                            fetchData(1, searchValue, sortField, sortDirection);
                          }}
                        >
                          <i className="fa fa-search"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                onChangePage={(page) => setCurrentPage(page)}
                onChangeRowsPerPage={(newPerPage) => {
                  setRowsPerPage(newPerPage);
                  setCurrentPage(1);
                }}
                onSort={(column, direction) => {
                  setSortField(column.sortField);
                  setSortDirection(direction);
                  setCurrentPage(1);
                }}
              />
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
}

export default TypeServices;
